/* Original H.264/AAC streams, packaged for HLS without transcoding. */
if (!customElements.get('shield-announcement-video')) {
  customElements.define('shield-announcement-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.message = this.querySelector('[role="status"]');
      this.video.controls = false;
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.start());
      this.video.addEventListener('error', () => this.fail());
    }

    start() {
      this.playRequested = true;
      this.message.hidden = true;
      this.button.hidden = true;
      this.video.controls = true;
      const play = () => {
        if (!this.playRequested) return;
        this.video.play().catch(() => {
          // The browser may require another tap on its native playback controls.
        });
      };
      if (this.hls) {
        this.hls.startLoad();
        play();
        return;
      }
      if (this.video.canPlayType('application/vnd.apple.mpegurl')) {
        if (!this.video.getAttribute('src') || this.reloadSource) {
          this.reloadSource = false;
          this.video.src = this.dataset.source;
        }
        play();
      } else if (window.Hls && window.Hls.isSupported()) {
        this.hls = new window.Hls({ backBufferLength: 30 });
        this.hls.on(window.Hls.Events.MANIFEST_PARSED, play);
        this.hls.on(window.Hls.Events.ERROR, (_event, data) => {
          if (data.fatal) this.fail();
        });
        this.hls.loadSource(this.dataset.source);
        this.hls.attachMedia(this.video);
      } else {
        this.fail('This browser cannot play the video. Please try Safari, Chrome, Firefox, or Edge.');
      }
    }

    pause() {
      this.playRequested = false;
      this.video.pause();
      this.hls?.stopLoad();
    }

    fail(message = 'The video could not load. Check your connection and try again.') {
      this.pause();
      this.reloadSource = true;
      this.hls?.destroy();
      this.hls = null;
      this.video.controls = false;
      this.button.hidden = false;
      this.button.querySelector('.sa-announcement-play__label').textContent = 'Retry video';
      this.message.textContent = message;
      this.message.hidden = false;
    }

    disconnectedCallback() {
      this.pause();
      this.hls?.destroy();
      this.hls = null;
    }
  });
}
